module.exports = __webpack_public_path__ + "img/figma.6eac459c.svg";